'use strict'

const defaultProps = {}

export const CLASS = defaultProps
